export const BATCH_WARNING_THRESHOLD_BYTES = 1024 * 1024 * 1024;

export function createPipelineFileEntry(file) {
  return {
    id: `${file.name}-${file.size}-${Date.now()}-${Math.random()}`,
    filename: file.name,
    file,
    selectedStages: { xmp: true, cover: true },
    stages: {
      xmp: { status: 'queued', progressPct: 0, error: null, s3Url: null, changes: [] },
      cover: {
        status: 'queued', progressPct: 0, error: null, resultBlob: null, dimensionInfo: null, resampleInfo: null,
      },
    },
  };
}
